import * as React from "react";
import { ITradeOwner } from 'src/services/interfaces/trade/tradeOwner/ITradeOwner';

export const ClientInfo = (props: { tradeOwner: ITradeOwner }) => (
  <div className="region-container client-info">
    <span className="subtitle">Informações do Cliente</span>
    <div>
      <div className="row">
        <span className="left description">Nome:</span>
        <span className="right description">{props.tradeOwner.fullName}</span>
      </div>
      <div className="row">
        <span className="left description">Documento:</span>
        <span className="right description">{props.tradeOwner.cpfCnpj}</span>
      </div>
      <div className="row">
        <span className="left description">Estado Civil:</span>
        <span className="right description">{props.tradeOwner.civilStatus}</span>
      </div>
      <div className="row">
        <span className="left description">Banco:</span>
        <span className="right description">{props.tradeOwner.bankData.bank}</span>
      </div>
      <div className="row">
        <span className="left description">Tipo de Conta:</span>
        <span className="right description">{props.tradeOwner.bankData.accountType}</span>
      </div>
      <div className="row">
        <span className="left description">Agencia:</span>
        <span className="right description">{props.tradeOwner.bankData.agency}</span>
      </div>
      <div className="row">
        <span className="left description">Conta:</span>
        <span className="right description">
          {props.tradeOwner.bankData.accountDigit ? `${props.tradeOwner.bankData.account}-${props.tradeOwner.bankData.accountDigit}` : props.tradeOwner.bankData.account}
        </span>
      </div>
    </div>
  </div>
);


// WEBPACK FOOTER //
// ./src/components/Refatoracao/TradeList/Components/ClientInfo/ClientInfo.tsx